<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Forms</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content pt-4 pb-1 px-3">

  <ng-container matColumnDef="only_archived" *ngIf="!show_date_picker_only">
    <div style="padding: 0 15px !important;">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" style="width:100%;" floatLabel="always" class="mb-4">
        <mat-label>Show Active or Archived Forms</mat-label>
        <mat-select [(ngModel)]="filter_options.only_archived" matTooltip="Filter forms by archival status." name="only_archived">
          <mat-option value="false">All Active</mat-option>
          <mat-option value="true">Only Archived</mat-option>
        </mat-select>
        <mat-hint>Use this to filter between active and archived forms.</mat-hint>
      </mat-form-field>
    </div>
  </ng-container>

  <div class="container-fluid" *ngIf="!show_date_picker_only">
    <div class="row">
      <div class="col">
        <button mat-raised-button color="secondary" type="button" style="width:100%;" class="mb-4" (click)="onSelectCategories()" [matBadge]="'' + (filter_options.category_ids && filter_options.category_ids.length ? filter_options.category_ids.length : '')" matTooltip="Select from a list of form categories in your account.">Categories</button>
      </div>
      <div class="col">
        <button mat-raised-button color="secondary" type="button" style="width:100%;" class="mb-4" (click)="onSelectSites()" [matBadge]="'' + (filter_options.site_ids && filter_options.site_ids.length ? filter_options.site_ids.length : '')" matTooltip="Select from a list of {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites').toLowerCase() }} in your account.">{{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}</button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button mat-raised-button color="secondary" type="button" style="width:100%;" class="mb-4" (click)="onSelectContractors()" [matBadge]="'' + (filter_options.contractor_ids && filter_options.contractor_ids.length ? filter_options.contractor_ids.length : '')" matTooltip="Select from a list of {{ utils.getLangTerm('contractors.plural', 'Contractors') }} in your account.">{{ utils.getLangTerm('contractors.plural', 'Contractors') }}</button>
      </div>
      <div class="col">
        <button mat-raised-button color="secondary" type="button" style="width:100%;" class="mb-4" (click)="onSelectUsers()" [matBadge]="'' + (filter_options.user_ids && filter_options.user_ids.length ? filter_options.user_ids.length : '')" matTooltip="Select from a list of users in your connected network.">Networked Users</button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button mat-raised-button color="secondary" type="button" style="width:100%;" class="mb-4" (click)="onSelectIndustries()" [matBadge]="'' + (filter_options.industry_ids && filter_options.industry_ids.length ? filter_options.industry_ids.length : '')" matTooltip="Select from a global list of industries.">Industries</button>
      </div>
      <div class="col">
        <button mat-raised-button color="secondary" type="button" style="width:100%;" class="mb-4" (click)="onSelectTrades()" [matBadge]="'' + (filter_options.trade_ids && filter_options.trade_ids.length ? filter_options.trade_ids.length : '')" matTooltip="Select from a global list of job titles.">Job Titles</button>
      </div>
    </div>
  </div>

  <ng-container matColumnDef="only_archived">
    <div style="padding: 0 1px !important;">
      <app-date-range-picker dateRangeTitle="Select Date Range" dateRangePlaceholder="Select Date Range" dateRangeTooltip="Filter forms by date range." [dateRangeInput]="filter_options.date_range" (dateRangeOutput)="getOutputDateRange($event)"></app-date-range-picker>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button type="button" mat-raised-button color="primary" (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button type="button" mat-raised-button color="secondary" (click)="onClearAndClose()">
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons" *ngIf="filter_options.date_range.length == 2">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearDateRange()">
        <mat-icon>clear</mat-icon> Clear Date Range
      </button>
    </div>
  </ng-container>
</mat-dialog-actions>
